export const textosSecciones = {
  titulo: 'Mis secciones',
  nueva: 'Nueva sección',
  etiquetaNombre: 'Nombre',
  etiquetaActividades: 'Actividades publicadas',
  crear: 'Crear sección',
  poner: 'Poner',
  sacar: 'Sacar',
  terminar: 'Borrar',
  copiarEnlace: 'Copiar enlace',
  sinFoto: 'Sin foto',
  nombreEnUso: 'Ese nombre ya está en uso',
  editarNombre: 'Cambiar nombre',
  guardarNombre: 'Guardar',
  cancelar: 'Cancelar',
};

export const enlaceDeSeccion = (slug: string) => `https://mobile.idem.social/actividad/lista?seccion=${slug}`;
